// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- Component needed */
:root {
    /* STATIC */
    --ds-label-static-0-color: var(--ds-color-grey-indigo-90);
    --ds-label-static-0-bg-color: var(--ds-color-neon);
    --ds-label-static-1-color: var(--ds-color-neon);
    --ds-label-static-1-bg-color: var(--ds-color-grey-indigo-70);
    --ds-label-static-2-color: var(--ds-color-indigo-1);
    --ds-label-static-2-bg-color: var(--ds-color-indigo-4);
    --ds-label-static-3-color: var(--ds-color-sand-2);
    --ds-label-static-4-color: var(--ds-color-indigo-1);
    --ds-label-static-5-color: var(--ds-color-pink-2);
    --ds-label-static-6-bg-color: var(--ds-color-grey-indigo-30);
    --ds-label-static-6-color: var(--ds-color-charcoal);
    /* DYNAMIC */
    --ds-label-dynamic-bg-color: var(--ds-color-grey-indigo-70);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
